import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { FiscoService } from 'src/app/app-core/services/fisco.service';
import { IbgeService } from 'src/app/app-core/lib/ibge.service';
import { CepService } from 'src/app/app-core/lib/cep.service';
import { Subject } from 'rxjs';
import { TransmitterItbiComponent } from './transmitter-itbi/transmitter-itbi.component';
import { AcquirerItbiComponent } from './acquirer-itbi/acquirer-itbi.component';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-application-itbi',
	templateUrl: './application-itbi.component.html',
	styleUrls: ['./application-itbi.component.scss'],
	providers: [IbgeService, CepService, FiscoService]
})
export class ApplicationItbiComponent implements OnDestroy, AfterViewInit {

	@ViewChild(TransmitterItbiComponent) transmitteritbicomponent: TransmitterItbiComponent;
	@ViewChild(AcquirerItbiComponent) acquirerItbiComponent: AcquirerItbiComponent;
	@Output() transmitenteAdicionalObrigatorioChange = new EventEmitter<boolean>();
	@Input() subject;
	@Input() applicantDetails;

	public estados: [];
	public municipiosPorEstado: [];
	public form?: FormGroup;
	public checkApplicantDataAcquirer = false;
	public checkApplicantDataTransmitter = false;
	public isTransmitterFirst = false;
	private destroy$ = new Subject();

	public naturezaDatransacao = [
		"Compra e Venda",
		"Cessão de Posse",
		"Alienação",
		"Alienação Fiduciária",
		"Anuência",
		"Cessão de Direitos",
		"Cessão de Direitos Hereditários",
		"Cessão de Posse e Transferência De Direitos Hereditários",
		"Cisão",
		"Compra e Venda com Anuência",
		"Consolidação da Propriedade",
		"Consolidação de Garantia",
		"Dação em Pagamento",
		"Desapropriação",
		"Direito de Posse",
		"Distrato",
		"Distrato Social",
		"Divorcio Consensual",
		"Incorporação ao Patrimônio",
		"Partilha de Bens",
		"Permuta",
		"Separação de Bens",
		"Separação Judicial Consensual",
		"Transferência de Direito Hereditários",
		"Transmissão de Bens ao Cônjuge",
		"Título de Domínio",
		"Usufruto",
		"Cisão Parcial",
		"Distrato de Doação",
		"Arrematação",
		"Instituição de servidão administrativa",
		"Desincorporação de Bens Imóveis em Razão da Extinção de Empresa",
		"Cessão de transferência",
		"Integralização ao Patrimônio",
		"Cessão de direitos de aquisição",
		"Concessão de Direito Real de Superfície"
	];


	constructor(
		public fb: FormBuilder,
		public fiscoService: FiscoService,
		public global: GlobalService,
	) {
		this.form = this.fb.group({
			tipoFormulario: ['adquirente', [Validators.required]],
			SOLIT_AdquirenteNome: [null, [Validators.required]],
			SOLIT_AdquirenteCPF: [null, [Validators.required]],
			SOLIT_AdquirenteEmail: [null, [Validators.required]],
			SOLIT_AdquirenteTelefone: [null, [Validators.required]],
			SOLIT_AdquirenteUF: [null, [Validators.required]],
			SOLIT_AdquirenteMunicipio: [null, [Validators.required]],
			SOLIT_AdquirenteLogradouro: [null, [Validators.required]],
			SOLIT_AdquirenteNumero: [null, [Validators.required]],
			SOLIT_AdquirenteBairro: [null, [Validators.required]],
			SOLIT_AdquirenteComplemento: [null],
			SOLIT_AdquirenteCEP: [null, [Validators.required]],
			SOLIT_TransmitenteNome: [null, [Validators.required]],
			SOLIT_TransmitenteCPF: [null, [Validators.required]],
			SOLIT_TransmitenteEmail: [null, [Validators.required]],
			SOLIT_TransmitenteTelefone: [null, [Validators.required]],
			SOLIT_TransmitenteUF: [null, [Validators.required]],
			SOLIT_TransmitenteMunicipio: [null, [Validators.required]],
			SOLIT_TransmitenteLogradouro: [null, [Validators.required]],
			SOLIT_TransmitenteNumero: [null, [Validators.required]],
			SOLIT_TransmitenteBairro: [null, [Validators.required]],
			SOLIT_TransmitenteComplemento: [null],
			SOLIT_TransmitenteCEP: [null, [Validators.required]],
			SOLIT_NaturezaTransacao: [null, [Validators.required]],
			SOLIT_DataInstrumento: [null, [Validators.required]],
			SOLIT_ValorTransacao: [null, [Validators.required]],
			SOLIT_PercentualTransmitido: [null, [Validators.required]],
			SOLIT_TransacaoMatricula: [null],
			SOLIT_TransacaoInscricao: [null],
			SOLIT_TransacaoEndereco: [null, [Validators.required]],
			SOLIT_TransacaoNumero: [null, [Validators.required]],
			SOLIT_TransacaoComplemento: [null],
			SOLIT_TransacaoLote: [null, [Validators.required]],
			SOLIT_TransacaoQuadra: [null, [Validators.required]],
			SOLIT_TransacaoTipoImovel: ['Urbano'],
			SOLIT_TransacaoNaturezaImovel: ['Territorial'],
			SOLIT_TransacaoAreaTerreno: [null, [Validators.required]],
			SOLIT_TransacaoAreaTotal: [null, [Validators.required]],
			SOLIT_TransacaoValorFinanciado: [null, [Validators.required]],
			SOLIT_TransacaoValorNaoFinanciado: [null, [Validators.required]],
			SOLIT_TransacaoTotalDeclarado: [null, [Validators.required]],
			transmitenteAdicional: this.fb.array([
				this.fb.group({
					nomeAdicional: [null],
					cpfCnpjAdicional: [null],
					cepAdicional: [null],
					ufAdicional: [null],
					municipioAdicional: [null],
					logradouroAdicional: [null],
					numeroAdicional: [null],
					bairroAdicional: [null],
					complementoAdicional: [null],
				})
			]),
			formVariants: this.fb.group({
				termCheck: [false]
			})
		});
		this.verifyFormtype();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.unsubscribe();
	}

	ngAfterViewInit() {
		this.setupDuplicadoValidation();
		this.syncTransmitterChanges();
	}

	verifyFormtype() {
		this.form.get('tipoFormulario').valueChanges.subscribe((value) => {
			this.isTransmitterFirst = (value == "transmitente");
		});
	}

	getAcquirerData(event) {
		this.form?.patchValue({
			SOLIT_AdquirenteNome: event.nome,
			SOLIT_AdquirenteCPF: event.CPF,
			SOLIT_AdquirenteEmail: event.email,
			SOLIT_AdquirenteTelefone: event.telefone,
			SOLIT_PercentualTransmitido: event.percentualTransmitido,
			SOLIT_TransacaoMatricula: event.transacaoMatricula,
			SOLIT_TransacaoInscricao: event.transacaoInscricao,
			SOLIT_TransacaoEndereco: event.transacaoEndereco,
			SOLIT_TransacaoNumero: event.transacaoNumero,
			SOLIT_TransacaoComplemento: event.transacaoComplemento,
			SOLIT_TransacaoLote: event.transacaoLote,
			SOLIT_TransacaoQuadra: event.transacaoQuadra,
			SOLIT_TransacaoTipoImovel: event.tipoImovel,
			SOLIT_TransacaoNaturezaImovel: event.naturezaImovel,
			SOLIT_TransacaoAreaTerreno: event.transacaoAreaTerreno,
			SOLIT_TransacaoAreaTotal: event.transacaoAreaTotal,
			SOLIT_TransacaoValorFinanciado: event.transacaoValorFinanciado,
			SOLIT_TransacaoValorNaoFinanciado: event.transacaoValorNaoFinanciado,
			SOLIT_TransacaoTotalDeclarado: event.transacaoTotalDeclarado,
			SOLIT_AdquirenteUF: event.uf,
			SOLIT_AdquirenteMunicipio: event.localidade,
			SOLIT_AdquirenteLogradouro: event.logradouro,
			SOLIT_AdquirenteNumero: event.numero,
			SOLIT_AdquirenteBairro: event.bairro,
			SOLIT_AdquirenteComplemento: event.complemento,
			SOLIT_AdquirenteCEP: event.CEP,
		});

		this.form.updateValueAndValidity();
	}

	getAddressTransmittedData(event) {

		this.form?.patchValue({
			SOLIT_TransmitenteMunicipio: event.localidade,
			SOLIT_TransmitenteBairro: event.bairro,
			SOLIT_TransmitenteLogradouro: event.logradouro,
			SOLIT_TransmitenteUF: event.uf,
			SOLIT_TransmitenteNumero: event.numero,
			SOLIT_TransmitenteComplemento: event.complemento,
			SOLIT_TransmitenteCEP: event.CEP,
			SOLIT_TransmitenteNome: event.nome,
			SOLIT_TransmitenteCPF: event.CPF,
			SOLIT_TransmitenteEmail: event.email,
			SOLIT_TransmitenteTelefone: event.telefone,
		});

		if (event.duplicados?.length) {
			const transmitenteAdicionalArray = this.form.get('transmitenteAdicional') as FormArray;

			while (transmitenteAdicionalArray.length) {
				transmitenteAdicionalArray.removeAt(0);
			}

			event.duplicados.forEach((dup) => {
				transmitenteAdicionalArray.push(this.fb.group({
					nomeAdicional: dup.nomeAdicional || null,
					cpfCnpjAdicional: dup.cpfCnpjAdicional || null,
					cepAdicional: dup.cepAdicional || null,
					ufAdicional: dup.ufAdicional || null,
					municipioAdicional: dup.municipioAdicional || null,
					logradouroAdicional: dup.logradouroAdicional || null,
					numeroAdicional: dup.numeroAdicional || null,
					bairroAdicional: dup.bairroAdicional || null,
					complementoAdicional: dup.complementoAdicional || null,
				}));
			});

			this.setDuplicadoValidators();
		}
		this.form.updateValueAndValidity();
	}

	private setupDuplicadoValidation() {
		this.transmitteritbicomponent.duplicarFormularioChange
			.pipe(takeUntil(this.destroy$)).subscribe((duplicar: boolean) => {
				this.transmitenteAdicionalObrigatorioChange.emit(duplicar);
				if (duplicar) {
					this.setDuplicadoValidators();
				} else {
					this.clearDuplicadoValidators();
				}
			});
	}


	private setDuplicadoValidators() {
		const transmitenteAdicionalArray = this.form.get('transmitenteAdicional') as FormArray;

		transmitenteAdicionalArray.controls.forEach((group: FormGroup) => {
			Object.keys(group.controls).forEach(controlName => {
				const control = group.get(controlName);
				if (!control) return;

				if (controlName && controlName !== 'complementoAdicional') {
					control.setValidators([Validators.required]);
				} else {
					control.clearValidators();
				}
				control.updateValueAndValidity({ emitEvent: true });
			});
			group.updateValueAndValidity({ emitEvent: true });
		});
	}

	private clearDuplicadoValidators() {
		const transmitenteAdicionalArray = this.form.get('transmitenteAdicional') as FormArray;

		transmitenteAdicionalArray.controls.forEach((group: FormGroup) => {
			Object.keys(group.controls).forEach(controlName => {
				const control = group.get(controlName);
				if (control) {
					control.clearValidators();
					control.updateValueAndValidity({ emitEvent: true });
				}
			});
			group.updateValueAndValidity({ emitEvent: true });
		});
	}

	// ------------------------------------------------------------------
	// Rascunho
	// ------------------------------------------------------------------

	/** Só o que é preenchido aqui; adquirente e transmitente guardam os próprios formulários. */
	public get draftValue(): any {
		return {
			tipoFormulario: this.form.get('tipoFormulario').value,
			SOLIT_NaturezaTransacao: this.form.get('SOLIT_NaturezaTransacao').value,
			SOLIT_ValorTransacao: this.form.get('SOLIT_ValorTransacao').value,
			SOLIT_DataInstrumento: this.form.get('SOLIT_DataInstrumento').value,
			adquirente: this.acquirerItbiComponent?.form?.getRawValue() || null,
			transmitente: this.transmitteritbicomponent?.form?.getRawValue() || null,
		};
	}

	/** O tipo de preenchimento é aplicado antes, por quem chama: ele recria adquirente e transmitente. */
	public restoreDraft(draft: any): void {
		this.form.patchValue({
			SOLIT_NaturezaTransacao: draft.SOLIT_NaturezaTransacao ?? null,
			SOLIT_ValorTransacao: draft.SOLIT_ValorTransacao ?? null,
			SOLIT_DataInstrumento: draft.SOLIT_DataInstrumento ?? null,
		});

		this.acquirerItbiComponent?.restoreDraft(draft.adquirente);
		this.transmitteritbicomponent?.restoreDraft(draft.transmitente);
	}

	clearAcquirerAndTransmitter(): void {
		this.acquirerItbiComponent?.reset();
		this.transmitteritbicomponent?.reset();
	}

	reset() {
		this.form.patchValue({
			SOLIT_NaturezaTransacao: null,
			SOLIT_DataInstrumento: '',
			SOLIT_ValorTransacao: ''
		});
		this.form.updateValueAndValidity();
	}

	private syncTransmitterChanges() {
		this.transmitteritbicomponent.onTransmitterChange
			.pipe(takeUntil(this.destroy$))
			.subscribe((transmitterData: any) => {
				const formArray = this.form.get('transmitenteAdicional') as FormArray;

				while (formArray.length) {
					formArray.removeAt(0);
				}

				if (transmitterData?.duplicados?.length) {
					transmitterData.duplicados.forEach(dup => {
						formArray.push(this.fb.group({
							nomeAdicional: dup.nomeAdicional || null,
							cpfCnpjAdicional: dup.cpfCnpjAdicional || null,
							cepAdicional: dup.cepAdicional || null,
							ufAdicional: dup.ufAdicional || null,
							municipioAdicional: dup.municipioAdicional || null,
							logradouroAdicional: dup.logradouroAdicional || null,
							numeroAdicional: dup.numeroAdicional || null,
							bairroAdicional: dup.bairroAdicional || null,
							complementoAdicional: dup.complementoAdicional || null,
						}));
					});
				}

				this.setDuplicadoValidators();
				this.form.updateValueAndValidity();
			});
	}
}
